module.exports = __webpack_public_path__ + "static/apple-icon-76x76-73603705b6075e80d567674618221201.png";